import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CompanyService } from 'src/app/company/company.service';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '../../app.service'
import { AdobelaunchService } from '../../_services/adobelaunch.service';
import { HttpService } from 'src/app/shared/http.service';
import { Role } from 'src/app/shared/models/user-model';
import { selectPrfName } from 'src/app/store/selectors/app.selector';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-annualstatementcomparison',
    templateUrl: './annualstatementcomparison.component.html',
    styleUrls: ['./annualstatementcomparison.component.scss'],
    standalone: false
})
export class AnnualstatementcomparisonComponent implements OnInit, AfterViewInit {

  currentYear: number;
  prfNumber: string;
  prfName: string;
  groupCode: string;
  compno: any;
  annualstatementlist: any[] = [];
  ascomparisonreportform: UntypedFormGroup;
  show: boolean = true;
  isReadOnlyAdmin: boolean;
  isCustomer: boolean = false;
  iconNote: boolean = false;
  serial:number = 1;
  showPageError: boolean = false;
  pageError: string = "";

  constructor(
    private companyService: CompanyService,
    private appService: AppService,
    private readonly store: Store,
    private router: Router, private AdobelaunchService: AdobelaunchService, private httpService: HttpService) { }

  ngAfterViewInit() {
    this.AdobelaunchService.EventEndDispatch();
  }
  ngOnInit(): void {
    this.compno = this.companyService.companyId;
    this.currentYear = this.companyService.currentYear;
    this.prfNumber = this.companyService.prfNumber;
    
    this.store.select(selectPrfName).subscribe(prfName => {
      this.prfName = prfName;
    });

    this.isReadOnlyAdmin = this.appService.isReadonlyAdmin;
    if (this.appService.hasRole(Role.Customer)) {
          this.isCustomer = true;
        }
    this.groupCode = this.companyService.groupCode;
    this.getPrgress();
    this.loadAnnualStatementreport();
  }

  getPrgress() {
    this.companyService.getCustomerPrfProgress(this.currentYear, this.compno, this.groupCode).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          console.log("Progress data loaded successfully");
        }
      },
      error: (error) => {
        this.router.navigate(['/apifailure']);
      }
    })
  }

  loadAnnualStatementreport() {
    this.annualstatementlist = [];
    this.companyService.loadAnnualStatementComparison(this.currentYear, this.groupCode, this.compno).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          this.show = false;
          this.annualstatementlist = resp["ascomparisondata"];
          let index = this.annualstatementlist.indexOf("mailid");
          this.annualstatementlist.splice(index, 1);
          this.annualstatementlist = this.annualstatementlist.filter(item => !(item.col1 === 0 && item.col2 === 0));
          for (const item of this.annualstatementlist) {
            if (item['mark'] != "")
              this.iconNote = true;
          }
          if( this.annualstatementlist.length == 0) {
            this.showPageError = true;
            this.pageError = "No comparison data available for this year.";
          }
        }
      },
      error: (error) => {
        this.router.navigate(['/apifailure']);
      }
    })
  }

  email() {
    sessionStorage.setItem("routename", `/${this.currentYear}/${this.prfNumber}/annualstatementcomparison`);
    this.router.navigate(['/emailpreview'])
  }



}
